import * as Diagram from "../../../../components/diagram";

export const CaseVisitDetail = {
  label: "個案追蹤明細",
  key: "CaseVisitDetail",
  path: "HepatitisTracking/CaseVisitDetail",
  api: "TCS_V_LiverCaseVisit",
  render: (options) => (
    <Diagram.HepatitisTracking.CaseVisitDetail {...options} />
  ),
  isRaw: true,
  isPage: true,
  filterColumns: [
    { key: "篩檢日期", type: "date" },
    { key: "案件狀態", type: "string" },
    { key: "追蹤回報結案", label: "結案原因", type: "string" },
  ],
  columns: [
    {
      key: "編號",
      field: "編號",
      header: "編號",
    },
    {
      key: "居住鄉鎮",
      field: "居住鄉鎮",
      header: "居住鄉鎮",
    },
    {
      key: "篩檢日期",
      field: "篩檢日期",
      header: "篩檢日期",
    },
    {
      key: "篩檢地點",
      field: "篩檢地點",
      header: "篩檢地點",
    },
    {
      key: "姓名",
      field: "姓名",
      header: "姓名",
    },
    {
      key: "性別",
      field: "性別",
      header: "性別",
    },
    {
      key: "年齡",
      field: "年齡",
      header: "年齡",
    },
    {
      key: "身分證字號",
      field: "身分證字號",
      header: "身分證號",
    },
    // {
    //   key: "地址",
    //   field: "地址",
    //   header: "地址",
    // },
    // {
    //   key: "電話",
    //   field: "電話",
    //   header: "電話",
    // },
    // {
    //   key: "手機",
    //   field: "手機",
    //   header: "手機",
    // },
    {
      key: "B肝",
      field: "B肝",
      header: "B肝",
    },
    {
      key: "C肝",
      field: "C肝",
      header: "C肝",
    },
    {
      key: "C肝病毒",
      field: "C肝病毒",
      header: "C肝病毒",
    },
    {
      key: "治療",
      field: "治療",
      header: "治療",
    },
    {
      key: "追蹤結果",
      field: "追蹤結果",
      header: "追蹤結果",
    },
    {
      key: "追蹤",
      field: "追蹤",
      header: "追蹤",
    },
    {
      key: "案件狀態",
      field: "案件狀態",
      header: "案件狀態",
    },
    {
      key: "結案",
      field: "結案",
      header: "結案",
    },
    {
      key: "處置",
      field: "處置",
      header: "處置",
    },
  ],
};
